// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/methods/firstparty/v1/activate_method.proto

/* eslint-disable */
import { ApiMethod } from "./common";

/** Request message to activate a payment method. */
export interface ApiActivateMethodRequest {
  /** Unique identifier of the method to activate. */
  readonly id: string;
}

/** Response message after activating a payment method. */
export interface ApiActivateMethodResponse {
  /** The activated payment method details. */
  readonly method: ApiMethod | null;
}

export const ApiActivateMethodRequest: MessageFns<ApiActivateMethodRequest> = {
  fromJSON(object: any): ApiActivateMethodRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiActivateMethodRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    return obj;
  },
};

export const ApiActivateMethodResponse: MessageFns<ApiActivateMethodResponse> = {
  fromJSON(object: any): ApiActivateMethodResponse {
    return { method: isSet(object.method) ? ApiMethod.fromJSON(object.method) : null };
  },

  toJSON(message: ApiActivateMethodResponse): unknown {
    const obj: any = {};
    if (message.method !== undefined && message.method !== null) {
      obj.method = ApiMethod.toJSON(message.method);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
